export const handleSubmit = (e) => {
  e.preventDefault()
}

export const fillZero = (n, float = false) => n < 10 ? float ? `${n}0` : `0${n}` : n

export const isUrl = (url) => {

  var protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;

  var localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/
  var nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;

  /**
   * Loosely validate a URL `string`.
   *
   * @param {String} string
   * @return {Boolean}
   */

  function check(string){
    if (typeof string !== 'string') {
      return false;
    }

    var match = string.match(protocolAndDomainRE);
    // if (!match) {
    //   return false;
    // }

    var everythingAfterProtocol = match ? match[1] : string;
    if (!everythingAfterProtocol) {
      return false;
    }

    if (localhostDomainRE.test(everythingAfterProtocol) ||
        nonLocalhostDomainRE.test(everythingAfterProtocol)) {
      return true;
    }

    return false;
  }

  return check(url)

}


// WEBPACK FOOTER //
// ./src/helpers.js